export default __webpack_public_path__ + "static/media/upmpost-logo.bf355131.png";